import type { ProgramContent } from '../types/content'

export interface DeadlineState {
  label: string
  detail: string
  tone: 'open' | 'upcoming' | 'closed' | 'neutral'
}

function startOfDay(value: Date) {
  return new Date(value.getFullYear(), value.getMonth(), value.getDate()).getTime()
}

export function getDeadlineState(
  application: ProgramContent['application'],
  now = new Date(),
): DeadlineState {
  if (!application.startsAt || !application.endsAt || application.status === 'check_official') {
    return {
      label: '공식 신청 일정 확인 필요',
      detail: `${application.currentQuarter}분기 신청일이 아직 등록되지 않았습니다.`,
      tone: 'neutral',
    }
  }

  const today = startOfDay(now)
  const startsAt = startOfDay(new Date(application.startsAt))
  const endsAt = startOfDay(new Date(application.endsAt))
  const day = 24 * 60 * 60 * 1000

  if (today < startsAt) {
    const remaining = Math.ceil((startsAt - today) / day)
    return {
      label: `신청 시작 D-${remaining}`,
      detail: `${application.currentQuarter}분기 신청을 준비해 주세요.`,
      tone: 'upcoming',
    }
  }

  if (today <= endsAt) {
    const remaining = Math.ceil((endsAt - today) / day)
    return {
      label: remaining === 0 ? '오늘 신청 마감' : `신청 마감 D-${remaining}`,
      detail: `${application.currentQuarter}분기 신청 기간입니다.`,
      tone: 'open',
    }
  }

  return {
    label: '이번 분기 신청 마감',
    detail: '다음 분기 일정이 발표되면 다시 확인해 주세요.',
    tone: 'closed',
  }
}

